export default "__VITE_ASSET__CncV5Dl___"